import React from 'react';
import { useRuleMeta } from '../utils/hooks';
import { AlertForwardRule, AlertForwardMeta } from '../utils/types';
import { useLocation } from 'react-router-dom';
import AlertRuleDetailContent from './detail';
import { FormLayout, ContentLayout, DivLayout } from '../utils/styled';
import { Spin } from 'antd';

const AlertRuleDetailPage = () => {
  const { state } = useLocation();
  const rule = state?.rule as AlertForwardRule | undefined;

  const { isLoading, data } = useRuleMeta(); // fetch
  const ruleMetaData = data as AlertForwardMeta | undefined;

  return (
    <FormLayout>
      <ContentLayout>
        <DivLayout>
          {isLoading || !ruleMetaData ? (
            <Spin tip="Loading..." />
          ) : !ruleMetaData.partners || ruleMetaData.partners.length === 0 ? (
            <div>No partners configured for this rule.</div>
          ) : (
            <AlertRuleDetailContent ruleMetaData={ruleMetaData} rule={rule} />
          )}
        </DivLayout>
      </ContentLayout>
    </FormLayout>
  );
};
export default AlertRuleDetailPage;
